export enum CommonRoutes {
    LOGIN = 'login',
    ARCHIVES = 'archives',
    ARCHIVE = 'archive',
    ITEMS = "items",
    ITEM = 'item',
    SPECIMENS = 'specimens',
    SPECIMEN = 'specimen'
}

export enum AuditRoutes {
    AUDIT_HOME = 'auditHome',
    CAMPAIGN_SEARCH = 'campaigns',
    CAMPAIGN = 'campaign',
    RECORD = "record",
    NEW_ITEMS = 'newItems',
    NEW_SPECIMENS = 'newSpecimens'
}

export enum ConditionReportRoutes {
    CONDITION_REPORT_HOME = 'conditionReportHome',
    EDIT_REPORT = 'edit_report',
    CONSULT_REPORT = 'consult_report',
    CLOSE_REPORTS = 'close-reports',
    CURRENT_REPORTS = 'current-rerports',
}

export enum TrackingRoutes {
    TRACKING_HOME = 'trackingHome',
    MOVEMENT = 'movement',
    MOVEMENTS = 'movements',
    TASK = 'task',
    TASKS = 'tasks',
    CONTAINER = 'container',
    CONTAINERS = 'containers',
}
